// extracted by mini-css-extract-plugin
module.exports = {"root":"paymentHeader_root__3Tw4O","column":"paymentHeader_column__2u61A"};